export const getInitialNameLetter = (name: string = "") => {
  const nameArray = name.split(" ") || [];
  const [firstName, lastName] = nameArray;
  if (nameArray?.length > 1) {
    return firstName?.charAt?.(0) + lastName.charAt?.(0);
  }
  return firstName?.charAt?.(0) || "";
};
